import React, { ReactNode } from 'react';
import { Grid, Paper, useMediaQuery, useTheme } from '@mui/material';
import { mb } from './theme/mbTokens';

/** MainLayout's phone TopBar. */
const TOP_BAR_HEIGHT_PX = 64;

interface Props {
  children: ReactNode;
  isHighlighted?: boolean;
  /** Flat page on the ground color: no card. Padded by the page inset; the page inside lays itself out within it. */
  bare?: boolean;
}

/** The routed page's frame: the first element sits one page inset from the top and both inline edges. */
export const PaperPage: React.FC<Props> = ({ children, isHighlighted, bare }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isPhoneInset = useMediaQuery(theme.breakpoints.down('md'));
  const inset = isPhoneInset ? mb.layout.pageInset.xs : mb.layout.pageInset.md;
  // Phones (< sm): MainLayout's 100dvh shell minus the TopBar; desktop has no top bar.
  const contentHeight = isSmallScreen ? `calc(100dvh - ${TOP_BAR_HEIGHT_PX}px)` : '100dvh';
  if (bare) {
    return (
      <Grid
        container
        flexDirection="column"
        flexWrap="nowrap"
        sx={{ height: contentHeight, p: mb.layout.pageInset, boxSizing: 'border-box', overflow: 'hidden' }}>
        {children}
      </Grid>
    );
  }
  return (
    <Paper
      elevation={2}
      sx={{
        height: `calc(${contentHeight} - ${theme.spacing(inset * 2)})`,
        m: mb.layout.pageInset,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden',
        ...(isHighlighted && { border: '4px solid', borderColor: 'mb.highlight' }),
      }}>
      {children}
    </Paper>
  );
};
